import { useNavigate } from "react-router-dom";
import Button from "./Button";

type CardProps = {
  data: {
    _id: string;
    heading: string;
    description: string;
    image: string;
  };
};

export default function NewsCard({ data }: CardProps) {
  const navigate = useNavigate();
  const src =
    data.image && data.image !== "avatar.jpg"
      ? data.image
      : "/images/residential-bg.jpg";

  return (
    <div className="bg-white rounded-xl border border-white">
      <img
        src={src}
        alt=""
        className="w-full h-60 object-cover object-center rounded-t-xl"
      />
      <div className="p-4">
        <p className="text-lg font-bold mb-3 line-clamp-1">{data.heading}</p>
        <div
          className={`text-gray-600 mb-3 line-clamp-3`}
          dangerouslySetInnerHTML={{ __html: data.description }}
        />
        <Button variant="primary" onClick={() => navigate(`/news/${data._id}`)}>
          Show More
        </Button>
      </div>
    </div>
  );
}
